import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Pages API
export const pagesAPI = {
  getAll: (filters = {}) => axios.get(`${API_URL}/pages`, { params: filters }),
  getById: (id) => axios.get(`${API_URL}/pages/${id}`),
  create: (data) => axios.post(`${API_URL}/pages`, data),
  update: (id, data) => axios.put(`${API_URL}/pages/${id}`, data),
  addUpdate: (id, message) => axios.post(`${API_URL}/pages/${id}/update`, { message }),
  respond: (id, response) => axios.post(`${API_URL}/pages/${id}/respond`, response),
  review: (id) => axios.post(`${API_URL}/pages/${id}/review`),
  complete: (id, outcome) => axios.post(`${API_URL}/pages/${id}/complete`, outcome),
  cancel: (id) => axios.delete(`${API_URL}/pages/${id}`)
};

// EHR API
export const ehrAPI = {
  getPatientFlags: (nhsNumber) => axios.get(`${API_URL}/ehr/patient/${nhsNumber}/critical-flags`),
  getInfectionStatus: (nhsNumber) => axios.get(`${API_URL}/ehr/patient/${nhsNumber}/infection-status`),
  getAdmissionHistory: (nhsNumber) => axios.get(`${API_URL}/ehr/patient/${nhsNumber}/admission-history`),
  checkInteraction: (nhsNumber, medication) => axios.post(`${API_URL}/ehr/patient/${nhsNumber}/check-interaction`, { medication }),
  getAllPatients: () => axios.get(`${API_URL}/ehr/patients`)
};

// Handover API
export const handoverAPI = {
  generate: () => axios.post(`${API_URL}/handover/generate`),
  transfer: (data) => axios.post(`${API_URL}/handover/transfer`, data),
  getHistory: () => axios.get(`${API_URL}/handover/history`)
};

// Dashboard API
export const dashboardAPI = {
  getMetrics: () => axios.get(`${API_URL}/dashboard/metrics`),
  getAuditLog: (filters = {}) => axios.get(`${API_URL}/dashboard/audit-log`, { params: filters }),
  getPerformance: (filters = {}) => axios.get(`${API_URL}/dashboard/performance`, { params: filters })
};

// Auth API
export const authAPI = {
  login: (email, password) => axios.post(`${API_URL}/auth/login`, { email, password }),
  logout: () => axios.post(`${API_URL}/auth/logout`),
  getUsers: (role) => axios.get(`${API_URL}/auth/users`, { params: { role } })
};

// Shifts API
export const shiftsAPI = {
  startShift: (notes) => axios.post(`${API_URL}/shifts/start`, { notes }),
  endShift: (notes) => axios.post(`${API_URL}/shifts/end`, { notes }),
  getActiveShift: () => axios.get(`${API_URL}/shifts/active`),
  getOnDutyDoctors: () => axios.get(`${API_URL}/shifts/on-duty`),
  getShiftHistory: (limit) => axios.get(`${API_URL}/shifts/history`, { params: { limit } }),
  delegatePage: (pageId, toDoctorId, reason, notes) => 
    axios.post(`${API_URL}/shifts/delegate`, { pageId, toDoctorId, reason, notes }),
  bulkDelegatePages: (pageIds, toDoctorId, reason) => 
    axios.post(`${API_URL}/shifts/bulk-delegate`, { pageIds, toDoctorId, reason }),
  getPageDelegations: (pageId) => axios.get(`${API_URL}/shifts/delegations/${pageId}`)
};
